import HomeDetail from '@/views/HomeDetail.vue'
const routes = [
    //首页
    {
        path: '/',
        name: 'HomePage',
        meta: { china:'首 页',en:'Home' },
		component: () => import('@/views/HomePage.vue'),
    },
	{
	    path: '/HomeEdit',
	    name: 'HomeEdit',
	    meta: { china:'列表',en:'list' },
		component: () => import('@/views/HomeEdit.vue'),
	},
	{
	    path: '/Search',
	    name: 'Search',
	    meta: { china:'搜索',en:'list' },
		component: () => import('@/views/Search.vue'),
	},
	{
	    path: '/Inquire',
	    name: 'Inquire',
	    meta: { china:'查询',en:'list' },
		component: () => import('@/views/Inquire.vue'),
	},
	{
	    path: '/InquireDetail',
	    name: 'InquireDetail',
	    meta: { china:'查询',en:'list' },
		component: () => import('@/views/InquireDetail.vue'),
	},
	{
	    path: '/HomeDetail',
	    name: 'HomeDetail',
	    meta: { china:'详情',en:'list' },
		component:HomeDetail
	},
	{
	    path: '/Xieyi',
	    name: 'Xieyi',
	    meta: { china:'查询',en:'list' },
		component: () => import('@/views/Xieyi.vue'),
	}
]

export default routes